function stripePlatformClientId() {
  if (process.env.NODE_ENV === 'production' && !process.env.REACT_APP_BPX_STRIPE_KEY) {
    throw 'missing REACT_APP_BPX_STRIPE_KEY ENV';
  }

  return process.env.REACT_APP_BPX_STRIPE_KEY || 'pk_test_FLIBS49OqEFDWVydmzwVoFKj';
}

export { stripePlatformClientId };
